(() => {
  if (window.grawrVideoJournalLoaded) return;
  window.grawrVideoJournalLoaded = true;
  document.addEventListener('play', event => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.gv')) return;
    document.querySelectorAll('.gv video').forEach(video => { if (video !== event.target) video.pause(); });
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('.gv video').forEach(video => video.pause());
  });
})();
